(function () {
  'use strict';
  if (window.CopyCode) { return; } // guard against accidental double-inclusion

  var SENTINEL   = '#copy-code';
  var TOKEN      = /\[\[copy-code:([^\]]+)\]\]/g;
  var DONE_LABEL = 'Skopiowano kod!';               // localization deferred: swap here
  var RESET_MS   = 1500;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, BUTTON: 1, NOSCRIPT: 1 };

  var ICON = '<svg class="copy-code-btn__icon" aria-hidden="true" viewBox="0 0 24 24"' +
    ' fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"' +
    ' stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"></rect>' +
    '<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>';

  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        ok ? resolve() : reject(new Error('execCommand returned false'));
      } catch (e) { reject(e); }
    });
  }

  function makeButton(code) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'copy-code-btn';
    btn.setAttribute('data-copy-code', code);
    btn.setAttribute('data-copy-code-done', '1');
    btn.setAttribute('aria-label', 'Copy code ' + code);
    btn.innerHTML = ICON +
      '<span class="copy-code-btn__label">' + escapeHtml(code) + '</span>' +
      '<span class="copy-code-btn__sr" role="status" aria-live="polite"></span>';
    return btn;
  }

  function flash(btn) {
    var label = btn.querySelector('.copy-code-btn__label');
    var live  = btn.querySelector('.copy-code-btn__sr');
    var code  = btn.getAttribute('data-copy-code');
    if (btn._t) { clearTimeout(btn._t); }
    btn.classList.add('is-copied');
    if (label) { label.textContent = DONE_LABEL; }
    if (live)  { live.textContent  = 'Kopiuj kod ' + code; }
    btn._t = setTimeout(function () {
      btn.classList.remove('is-copied');
      if (label) { label.textContent = code; }
      if (live)  { live.textContent  = ''; }
      btn._t = null;
    }, RESET_MS);
  }

  function onClick(e) {
    var btn = e.target.closest ? e.target.closest('.copy-code-btn') : null;
    if (!btn) { return; }
    e.preventDefault();
    copyText(btn.getAttribute('data-copy-code')).then(
      function () { flash(btn); },
      function () { flash(btn); } // clipboard blocked: still confirm to the user
    );
  }

  // Pass 1 -- rich-text links to the sentinel.
  function upgradeLinks(root) {
    var links = root.querySelectorAll('a[href="' + SENTINEL + '"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var code = (a.textContent || '').trim();
      if (!code) { continue; }
      a.parentNode.replaceChild(makeButton(code), a);
    }
  }

  // Pass 2 -- plain-text tokens.
  function upgradeTokens(root) {
    if (!root || !document.createTreeWalker) { return; }
    var stop = root.parentNode;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || node.nodeValue.indexOf('[[copy-code:') === -1) {
          return NodeFilter.FILTER_REJECT;
        }
        var p = node.parentNode;
        while (p && p !== stop) {
          if (p.nodeType === 1) {
            if (SKIP[p.nodeName]) { return NodeFilter.FILTER_REJECT; }
            if (p.isContentEditable) { return NodeFilter.FILTER_REJECT; }
            var ce = p.getAttribute && p.getAttribute('contenteditable');
            if (ce === '' || ce === 'true') { return NodeFilter.FILTER_REJECT; }
          }
          p = p.parentNode;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var targets = [], n;
    while ((n = walker.nextNode())) { targets.push(n); }
    for (var i = 0; i < targets.length; i++) { replaceTokens(targets[i]); }
  }

  function replaceTokens(textNode) {
    var text = textNode.nodeValue;
    TOKEN.lastIndex = 0;
    var frag = document.createDocumentFragment();
    var last = 0, m, found = false;
    while ((m = TOKEN.exec(text))) {
      found = true;
      if (m.index > last) { frag.appendChild(document.createTextNode(text.slice(last, m.index))); }
      frag.appendChild(makeButton(m[1].trim()));
      last = m.index + m[0].length;
    }
    if (!found) { return; }
    if (last < text.length) { frag.appendChild(document.createTextNode(text.slice(last))); }
    textNode.parentNode.replaceChild(frag, textNode);
  }

  function enhance(root) {
    root = root || document.body;
    if (!root) { return; }
    upgradeLinks(root);   // already-upgraded links are gone, so this is idempotent
    upgradeTokens(root);  // already-upgraded tokens are gone, so this is idempotent
  }

  document.addEventListener('click', onClick); // one delegated listener for all buttons

  function init() { enhance(document.body); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-enhance a section when it is added/reloaded in the customizer.
  document.addEventListener('shopify:section:load', function (e) {
    enhance(e.target || document.body);
  });

  window.CopyCode = { enhance: enhance, copyText: copyText };
})();